export default {
    CHAIN_ID: process.env.REACT_APP_CHAIN_ID || "",
    RPC: process.env.REACT_APP_RPC || "",
    REST: process.env.REACT_APP_REST || "",
    SEFI_CONTRACT_ADDRESS: process.env.REACT_APP_SEFI_CONTRACT_ADDRESS || "",
    FACTORY_CONTRACT_ADDRESS: process.env.REACT_APP_FACTORY_CONTRACT_ADDRESS || "",
}